module.exports = __webpack_public_path__ + "static/media/medly-screen.90b80717.png";